/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { createGlobalStyle } from 'styled-components';
import { renderSwitchButtons } from '../../utils/helpers/view/detailsHelper';
import { TabProps } from '../../utils/Interface';
import ContractUsers from './ContractUsers';
import RightsUsers from './RightsUsers';
import { AdministrationApi } from '../../utils/api';

// Create UserContext
export const UserContext = React.createContext<{ userData: any[]; getUsers: () => Promise<any>; loading: boolean; }>({
  userData: [],
  getUsers: async () => {},
  loading: false,
});

const AdministrationView = () => {
  // state variables
  const [userData, setUserData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [tabsStates, setTabsStates] = useState<TabProps[]>([
    { id: 0, label: 'Affecter droits', active: true },
    { id: 1, label: 'Affecter contrats', active: false },
  ]);
  
  // function to get users informations
  const getUsers = async () => {
    setLoading(true);
    try {
      const response = await AdministrationApi.getUsers();
      setUserData(response?.data);
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <Container className='sds-reset-style parameterClass'>
      <Styles />
      {/* titre de l'onglet */}
      <Container>
        <Word
          variant='p'
          textStyle='title'
          value='ADMINISTRATION'
          className='page-title'
        />
      </Container>
      <div>
        {renderSwitchButtons(tabsStates, setTabsStates)}
      </div>
      <UserContext.Provider value={{ userData: userData, getUsers: getUsers, loading: loading }}>
        <div style={{ display: tabsStates[1].active ? 'block' : 'none' }}>
          <ContractUsers />
        </div>
        <div style={{ display: tabsStates[0].active ? 'block' : 'none' }}>
          <RightsUsers />
        </div>
      </UserContext.Provider>
    </Container>
  );
};

export const Styles = createGlobalStyle`
.parameterClass{
  margin-left: 37vh;
  margin-right: 2%;
  margin-bottom: 2%;
  width:80%;
  .hide-vue-pluie, .hide-vue-ecp, .hide-vue-ili, .hide-vue-scoring-grid{
    display: none;
  }
  .vue-scoring-grid{
    align-items : center;
  }
}`;
export default AdministrationView;
